<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.costItemCode">
              <j-input :placeholder="$t('label.pleaseEnterCostItemCode')" v-model="queryParam.costCode"></j-input>
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.costItemName">
              <j-input :placeholder="$t('label.pleaseEntercostItemName')" v-model="queryParam.costName"></j-input>
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchQuery" icon="search" text="button.search"></mtc-button>
              <mtc-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" text="button.reset"></mtc-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <mtc-button @click="handleAdd" type="primary" icon="plus" text="button.add"></mtc-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('button.delete') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('tip.selected') }} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
       
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>

          <a-divider type="vertical" />
          <a-dropdown>
            <mtc-button type="link" size="small" text="button.more"><a-icon type="down" /></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <mtc-button type="link" size="small" text="button.details"></mtc-button>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-cap-cost-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import EfsCapCostModal from './modules/EfsCapCostModal'
    import '@/assets/less/TableExpand.less'
    import JInput from '@/components/jeecg/JInput'

    export default {
        name: "EfsCapCostList",
        mixins:[JeecgListMixin],
        components: {
            EfsCapCostModal,
            JInput
        },
        data () {
            return {
                description: 'efs_cap_cost管理页面',
                // 表头
                columns: [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:function (t,r,index) {
                            return parseInt(index)+1;
                        }
                    },
                    // {
                    //   title:'公司',
                    //   align:"center",
                    //   width:260,
                    //   dataIndex: 'companyCode_dictText'
                    // },
                    // {
                    //   title:'服务组',
                    //   align:"center",
                    //     width:160,
                    //   dataIndex: 'groupCode_dictText'
                    // },
                    {
                        slotName: 'tableHeader.costItemCode',
                        scopedSlots: { title: 'tableHeader.costItemCode'},
                        align:"center",
                        width:160,
                        dataIndex: 'costCode'
                    },
                    {
                        slotName: 'tableHeader.costItemName',
                        scopedSlots: { title: 'tableHeader.costItemName'},
                        align:"center",
                        width:260,
                        dataIndex: 'costName'
                    },
                    {
                        slotName: 'tableHeader.type',
                        scopedSlots: { title: 'tableHeader.type'},
                        align:"center",
                        width:160,
                        dataIndex: 'types_dictText'
                    },
                    {
                        slotName: 'tableHeader.operation',
                        dataIndex: 'action',
                        align:"center",
                        fixed:"right",
                      scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
                    }
                ],
                url: {
                    list: "/costList/efsCapCost/list",
                    delete: "/costList/efsCapCost/delete",
                    deleteBatch: "/costList/efsCapCost/deleteBatch",
                    exportXlsUrl: "/costList/efsCapCost/exportXls",
                    importExcelUrl: "costList/efsCapCost/importExcel",

                },
                dictOptions:{},
            }
        },
        created() {
        },
        computed: {
            importExcelUrl: function(){
                return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
            }
        },
        methods: {
            initDictConfig(){
            },

        }
    }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>